export default {
  "associates": {
    "title": "Associados",
    "search_placeholder": "Buscar Associado...",
    "view_profile": "🔍 Visualizar Perfil",
    "no_results": "Nenhum associado encontrado.",
    "back_to_home": "Voltar para Home",
    "about": "Sobre",
    "products": "Produtos",
    "certifications": "Certificações",
    "show":"Exibir",
    "all":"Todos",
  }
}
